// jshint esversion: 6
let heroSlider = document.querySelector( '.js-hero-slider' );
let videos = document.getElementsByClassName( 'js-slider-slide__video' );

// Sets the height of all slides to the height of the tallest slide
function equalSlideHeight () {
    let slickTrack = heroSlider.querySelector( '.slick-track' );
    let trackHeight;
    let slides = heroSlider.querySelectorAll( '.js-slider-slide' );

    // Set the height to auto to adjust for potential content size change
    for ( let i = 0; i < slides.length; i++ ) {
        slides[i].style.height = 'auto';
    }

    // Set the slides' heights to the height of the tallest slide
    trackHeight= slickTrack.offsetHeight;
    for ( let i = 0; i < slides.length; i++ ) {
        slides[i].style.height = trackHeight + 'px';
    }
}

// Play video on active slide, pause videos on inactive slides
function videoPlayPause (currentSlide, playState) {
    let sliderPanels = heroSlider.querySelectorAll('.js-slider-slide:not(.slick-cloned)');
    let currentPanel = sliderPanels[currentSlide];
    let currentVideo = currentPanel.querySelector('.js-slider-slide__video');
    let preCloned = heroSlider.querySelector('.js-slider-slide.slick-cloned:first-child');
    let postCloned = heroSlider.querySelector('.js-slider-slide.slick-cloned:last-child');
    let clonedVideo;

    // First slide in slider - keep last clone consistent
    if ( ( 0 === currentSlide ) && postCloned ) {
        clonedVideo = postCloned.querySelector('.js-slider-slide__video');
    }

    // Last slide in slider - keep first clone consistent
    if ( ( currentSlide === sliderPanels.length - 1 ) && preCloned ) {
        clonedVideo = preCloned.querySelector('.js-slider-slide__video');
    }

    // Manage playState on the cloned video
    if ( clonedVideo ) {

        if ( 'play' === playState ) {
            clonedVideo.play();

        } else {
            clonedVideo.pause();
        }
    }

    // Manage playState on the actual video
    if ( currentVideo ) {

        if ( 'play' === playState ) {
            currentVideo.play();

        } else {
            currentVideo.pause();
        }
    }
}

// Slides with video backgrounds
if ( videos.length ) {

    // Pause current video when leaving slide
    $(heroSlider).on('beforeChange', function (e, slick, currentSlide, nextSlide) {
       videoPlayPause(currentSlide, 'pause' );
    });

    // Play current video when entering slide
    $(heroSlider).on('afterChange', function (e, slick, currentSlide) {
       videoPlayPause(currentSlide, 'play' );
    });

}

// Equalize the slide heights on slider position change
$(heroSlider).on('setPosition', equalSlideHeight);
